import { createFileRoute } from "@tanstack/react-router";
import Partners from "@/pages/Partners";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/partner/")({
  head: () => routeHead("/de/partner/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Partners />
  );
}
